import { Center, Loader } from '@mantine/core';

export function DefaultPending() {
  return (
    <Center h="100%" w="100%">
      <Loader role="progressbar" />
    </Center>
  );
}
